import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M3.33337 4.66667C3.33337 4.29848 3.63185 4 4.00004 4H12C12.3682 4 12.6667 4.29848 12.6667 4.66667C12.6667 5.03486 12.3682 5.33333 12 5.33333H4.00004C3.63185 5.33333 3.33337 5.03486 3.33337 4.66667Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M3.33337 8C3.33337 7.63181 3.63185 7.33333 4.00004 7.33333H10C10.3682 7.33333 10.6667 7.63181 10.6667 8C10.6667 8.36819 10.3682 8.66667 10 8.66667H4.00004C3.63185 8.66667 3.33337 8.36819 3.33337 8Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M4.00004 10.6667C3.63185 10.6667 3.33337 10.9651 3.33337 11.3333C3.33337 11.7015 3.63185 12 4.00004 12H7.33337C7.70156 12 8.00004 11.7015 8.00004 11.3333C8.00004 10.9651 7.70156 10.6667 7.33337 10.6667H4.00004Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}